module.exports = __webpack_public_path__ + "img/9.92bf7127.gif";